import 'swiper/css/pagination';

import React from 'react';
import {Pagination} from 'swiper/modules';

import SwiperCarousel from '@/components/Swiper/SwiperCarousel';
import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';
import {twx} from '@/utils/tailwindUtils';

const AdvancedDiagnosticCarousel = ({children, swiperOptions, className}) => {
    const isMobile = useIsMobileLayout();

    return (
        <SwiperCarousel
            options={{
                ...swiperOptions,
                style: {width: '100%'},
                pagination: isMobile ? {} : false,
                breakpoints: {
                    0: {
                        slidesOffsetBefore: 16,
                        slidesOffsetAfter: 16,
                    },
                    744: {
                        slidesOffsetBefore: 32,
                        slidesOffsetAfter: 32,
                    },
                    1280: {
                        slidesOffsetBefore: 64,
                        slidesOffsetAfter: 64,
                    },
                },
            }}
            modules={isMobile ? [Pagination] : []}
            className={twx(isMobile && 'pb-10', className)}
        >
            {children}
        </SwiperCarousel>
    );
};

export default AdvancedDiagnosticCarousel;
